import React, {useState, useEffect} from 'react';

import { Progress, Divider, Spin, Modal} from 'antd';

import { FormattedMessage, useIntl } from "react-intl";

import {academyAPI} from '../../../../API/academy.api';

import {HTML5Backend} from 'react-dnd-html5-backend';
import {TouchBackend} from 'react-dnd-touch-backend';
import { DndProvider } from 'react-dnd';
import { isMobileOnly } from 'react-device-detect';
import EmptyList from './empty';
import ListTabs from './tabs';
import ListModal from './modal';
import Lesson from './lesson';
import SettingList from './settingList';

const { confirm } = Modal;

const LIST = 'list';
const LESSON = 'lesson';
const DELETE = 'delete';
const EDIT = 'edit';

const LessonsList = ({state, changeState, loginLoad, save, percent, setPercent, currentTime, setCurrentTime, lists=[], setLists, lessons=[], setLessons}) => {
    const { edit, tabLoad, activeListKey, lessonsLoad } = state;

    const intl = useIntl();
    
    const openModalForCreateNewList = (type, action=null) => {
      changeState({
        modalShow: true,
        type,
        action
      });

    };
    
    const deleteItem = (type) => {
      confirm({
        title: intl.formatMessage({id: 'Delete list?', defaultMessage: 'Delete list?'}),
        okText: intl.formatMessage({ id: 'Yes', defaultMessage: 'Yes' }),
        okType: 'danger',
        cancelText: intl.formatMessage({ id: 'No', defaultMessage: 'No' }),
        onOk() {
          const index = lists.findIndex(x => x.id === activeListKey);
          const data = {...lists[index]};
          data.deleted = 1;

          academyAPI.save(data)
          .then(res => console.log(res))
          .catch(err => console.log(err));
  
          const newIndex = index > 0 ? index-1 : index;
          const newPanes = [...lists];
          newPanes.splice(index, 1);

          setLists([...newPanes]);

          changeState({
            lists: [...newPanes],
            activeListKey: newPanes[newIndex]['id']
          })
        },
        onCancel() {
          return null;
        },
      });
    }



    return (
      <>

        {loginLoad || tabLoad ? <Spin /> : lists.length === 0 ? (
          <EmptyList 
            openModalForCreateNewList={openModalForCreateNewList} 
            titleBtn={<FormattedMessage id="Create new list" defaultMessage="Create new list"/>}
            description={intl.formatMessage({id: 'No list yet', defaultMessage: 'No list yet'})}
            modalType={LIST}
            edit={edit}
          />
        ) : (
        <>
          <ListTabs 
              openModalForCreateNewList={openModalForCreateNewList}
              activeListKey={activeListKey}
              lists={lists}
              modalType={LIST}
              edit={edit}
              state={state}
              changeState={changeState}
          />

          <Divider orientation="left/right" className="divider_academy"/>

          {edit ? <SettingList 
            openModalForCreateNewList={openModalForCreateNewList}
            modalType={LIST}
            LESSON={LESSON}
            EDIT={EDIT}
            deleteItem={deleteItem}
          /> : null}

          {lessonsLoad ? <Spin /> : lessons.length === 0 ? (
            <EmptyList 
                openModalForCreateNewList={openModalForCreateNewList} 
                titleBtn={<FormattedMessage id="Create new lesson" defaultMessage="Create new lesson"/>}
                description={intl.formatMessage({id: 'No lesson yet', defaultMessage: 'No lesson yet'})}
                modalType={LESSON}
              />
          ) : (
            <DndProvider backend={isMobileOnly ? TouchBackend : HTML5Backend}> 
              <Lesson 
                lessons={lessons} 
                setLessons={setLessons}
                percent={percent} 
                setPercent={setPercent}
                openModalForCreateNewList={openModalForCreateNewList} 
                modalType={LESSON}
                state={state}
                lists={lists}
                changeState={changeState}
                currentTime={currentTime} 
              />
            </DndProvider>
          )}

         </>
      )}
    </>
    )
}

export default LessonsList;